import React from 'react';
import { Button, ButtonSize, ButtonType } from '@ids/react-button';

const ModalPrimaryButton = ({ text, canSubmit, formId }) => {
  return (
    <Button size={ButtonSize.MEDIUM} type={ButtonType.FILLED} form={formId} disabled={!canSubmit} htmlType="submit">
      {text}
    </Button>
  );
};

export default ModalPrimaryButton;
